import axios from 'axios';

const baseApiUrl = 'process-api';
const baseApiDeployment = `${baseApiUrl}/repository/deployments`;
const baseApiProcessDefinition = `${baseApiUrl}/repository/process-definitions`;
const baseApiProcessInstance = `${baseApiUrl}/runtime/process-instances`;
const baseApiHistoricProcessInstance = `${baseApiUrl}/history/historic-activity-instances`
const baseApiTask = `${baseApiUrl}/runtime/tasks`;

export default class FlowableService {

  public getDeploymentResourceData(deploymentId: string, resourceId: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiDeployment}/${deploymentId}/resourcedata/${encodeURI(resourceId)}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getProcessDefinition(deploymentId: string) {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiProcessDefinition}?deploymentId=${deploymentId}`)
        .then(function(res) {
          const list: any[] = res.data.data;
          resolve(list.length ? list[0] : null);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAssignedTask(username: string, processInstanceId: string) {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiTask}?assignee=${username}&processInstanceId=${processInstanceId}&active=true`)
        .then(function(res) {
          const list: any[] = res.data.data;
          resolve(list.length ? list[0] : null);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getHistoricProcessInstance(processInstanceId: string) {
    return new Promise<any[]>((resolve, reject) => {
      axios
        .get(`${baseApiHistoricProcessInstance}?processInstanceId=${processInstanceId}&size=1000`)
        .then(function(res) {
          const activities = res.data.data
            .filter(activity => {
              const types = new Set(['startEvent', 'endEvent', 'sequenceFlow', 'exclusiveGateway', 'inclusiveGateway']);
              return !types.has(activity.activityType);
            });

          resolve(activities);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateTask(taskId: string, variables: any[]) {
    return new Promise<boolean>((resolve, reject) => {
      axios
        .post(`${baseApiTask}/${taskId}`, {
          action: 'complete',
          variables
        })
        .then(() => resolve(true))
        .catch(err => {
          reject(err);
        });
    });
  }
}
